import type { ImportTemplateParams } from '@/api/review-services/review-questionnaire/types';
import type { CycleQuestionnaire } from '@/types/cycle-evaluation/CycleQuestionnaire';

import { api } from '@/api/api';
import { filterOutOtherOption } from '@/utils/question';

export default {
    async getCycleQuestionnaire(cycleEvaluationId: string) {
        const response = await api.get(`/cyclequestionnaire/${cycleEvaluationId}`);
        return response.data;
    },

    async updateCycleQuestionnaire(questionnaire: CycleQuestionnaire) {
        const payload: CycleQuestionnaire = {
            ...questionnaire,
            reviewQuestions: questionnaire.reviewQuestions.map((question) => ({
                ...question,
                reviewQuestionOptions: filterOutOtherOption(question.reviewQuestionOptions),
            })),
        };
        const response = await api.put(`/cyclequestionnaire/${questionnaire.id}`, payload);
        return response.data;
    },

    async importTemplateInQuestionnaire(
        payload: ImportTemplateParams,
    ): Promise<CycleQuestionnaire> {
        const response = await api.put(
            `/cyclequestionnaire/${payload.questionnaireId}/importtemplate`,
            {
                templateId: payload.templateId,
            },
        );

        return response.data;
    },
};
